export default "__VITE_ASSET__3fEfX3yZ__"